import { APP_VERSION } from '@/constants';

const initializeFooterContent = () => ({ version: APP_VERSION, year: new Date().getFullYear(), text: 'Wizeline' });

export default { initializeFooterContent };
